'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M9.606 16.396a.36.36 0 0 1 .32.161c.072.107.108.263.108.47 0 .214-.034.372-.105.475-.07.102-.177.154-.323.154a.36.36 0 0 1-.32-.159c-.071-.107-.107-.263-.107-.47 0-.216.035-.375.105-.478.07-.102.177-.153.322-.153Zm.978 0a.36.36 0 0 1 .32.161c.072.107.108.263.108.47 0 .214-.034.372-.105.475-.07.102-.177.154-.323.154a.36.36 0 0 1-.32-.159c-.071-.107-.107-.263-.107-.47 0-.216.035-.375.105-.478.07-.102.177-.153.322-.153Zm-1.737.019v1.224h-.26v-.708l.004-.117.004-.127a1.494 1.494 0 0 1-.09.085l-.14.113-.125-.156.394-.314h.213Zm3.458.27c.106 0 .186.028.241.082.054.055.081.142.081.262v.61h-.256v-.547a.274.274 0 0 0-.034-.152c-.022-.033-.058-.05-.106-.05-.063 0-.11.022-.14.067-.032.044-.047.115-.047.212v.47h-.254v-.547a.283.283 0 0 0-.034-.152c-.023-.033-.058-.05-.107-.05-.065 0-.113.024-.142.072a.467.467 0 0 0-.045.237v.44h-.255v-.936h.195l.034.12h.015a.254.254 0 0 1 .109-.101.352.352 0 0 1 .163-.036c.14 0 .235.045.283.137h.023a.248.248 0 0 1 .111-.101.37.37 0 0 1 .165-.036Zm-4.41-.118v.201l-.574.265.573.235v.201l-.832-.367v-.12l.832-.415Zm1.71.038c-.06 0-.103.033-.13.098a.964.964 0 0 0-.04.324c0 .15.014.258.04.323.026.065.07.097.13.097s.105-.033.132-.099a.942.942 0 0 0 .04-.321.928.928 0 0 0-.041-.324c-.027-.065-.07-.098-.13-.098Zm.979 0c-.061 0-.104.033-.131.098a.964.964 0 0 0-.04.324c0 .15.014.258.04.323.026.065.07.097.13.097s.105-.033.132-.099a.942.942 0 0 0 .04-.321.928.928 0 0 0-.041-.324c-.027-.065-.07-.098-.13-.098Zm2.464-.261c.044 0 .084.009.118.025a.19.19 0 0 1 .08.068.189.189 0 0 1 .028.101.259.259 0 0 1-.017.092.392.392 0 0 1-.054.089 1.34 1.34 0 0 1-.128.129l-.091.086v.007h.31v.127h-.498v-.105l.179-.181a1.52 1.52 0 0 0 .103-.113.218.218 0 0 0 .035-.058.137.137 0 0 0 .011-.056c0-.029-.008-.05-.024-.064a.089.089 0 0 0-.062-.021.191.191 0 0 0-.08.019.479.479 0 0 0-.082.054l-.082-.097a.354.354 0 0 1 .255-.102Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m18.18 13-12.353.005a.322.322 0 0 0-.322.321v1.886h.643v-1.564h7.211v2.107h.642v-2.107l3.857-.005v6.709l-3.857.005v-1.69h-.642v1.69H6.143v-3.619H5.5v3.941c0 .177.144.321.32.321l12.36-.005c.176 0 .32-.144.32-.321v-7.353a.321.321 0 0 0-.32-.321",
    fill: "#3F3E4B"
  })));
});
var FwSet0Livingspace100 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Livingspace100 = FwSet0Livingspace100;